import { transitionend } from "@front/dom";

export function popupPane(pane: HTMLElement | JQuery, container: HTMLElement | JQuery, triggerLink: HTMLElement | JQuery, title?: string) {
  var $pane = $(pane);
  var $container = $(container);
  var $triggerLink = $(triggerLink);

  if (title) {
    var $title = $pane.data('$title');
    if ($title && $pane.data('title') !== title) {
      $title.remove();
      $title = undefined;
    }
    if (!$title) {
      $title = $('<div class="popupTitle">' + title + '</div>');
      $pane.data('$title', $title);
      $pane.data('title', title);
      $pane.prepend($title);
    }
  }

	$pane.addClass('popupHidden popupPane');
	$pane.css('width', $triggerLink.outerWidth());
  $container.append($pane);
  $pane.trigger('initPane');

	var editorHeight = $container.height();
	var positionOffset = $triggerLink.offset();
	var editorOffset = $container.offset();
	var paneHeight = $pane.outerHeight();
	var targetHeight = $triggerLink.outerHeight();
	var relativeTop = positionOffset.top - editorOffset.top;
	var relativeLeft = positionOffset.left - editorOffset.left;

  // Position below editor
	if (relativeTop + targetHeight + paneHeight < editorHeight) {
		$pane.css({
			top: relativeTop + targetHeight,
			left: relativeLeft
		});
	}
	// Position above editor
	else if (relativeTop-paneHeight > 0) {
		$pane.css({
			top: relativeTop - paneHeight,
			left: relativeLeft
		});
  }
  // Position centered if it's to tall both over and below
  else {
    $pane.css({
      top: (editorHeight-paneHeight)/2,
      left: relativeLeft
    });
  }
  // 
  $pane.removeClass('popupHidden');
  
  $pane.one('close', async function() {
    $(document).off('click', removeClick);
    $pane.addClass('popupHidden');
    await transitionend($pane[0]);
    $pane.detach();
    $pane.removeClass('popupPane popupHidden');
  });

  function removeClick(e) {
    if (e.which !== 1) {
      return;
    }
    let $target = $(e.target);
    if ($target.parents().add($target).filter($pane).length > 0 || $target.is(pane)) {
      $(document).one('click', removeClick);
    } else {
      $pane.trigger('close');
    }
  };

  // Allow dragging
  $pane.on('mousedown', function(e) {
    if (e.target.tagName.toUpperCase() === 'INPUT') {
      // We should be allowed to select text
      return;
    }

    var $body = $('body');
    var startX = e.pageX;
    var startY = e.pageY;
    var startPosX = parseInt($pane.css('left'));
    var startPosY = parseInt($pane.css('top'));
    var moved = false;
    function move(e) {
      if (!moved) {
        $body.addClass('dragPane');
        $pane.addClass('dragPane');
        moved = true;
      }
      var diffX = e.pageX-startX;
      var diffY = e.pageY-startY;
      $pane.css({
        left: startPosX + diffX,
        top: startPosY + diffY
      });
      e.preventDefault();
      e.stopPropagation();
    }
    $(document).on('mousemove', move);
    $(document).one('mouseup', function(e) {
      $(document).off('mousemove', move);
      if (moved) {
        $body.removeClass('dragPane');
        $pane.removeClass('dragPane');
        $(e.target).one('click', false); // Avoid triggering "click" on release
        return false;
      }
    });
  });

  setTimeout(function() {
    $(document).one('click', removeClick);
  }, 10);

};
